import React, { Component } from 'react'
import { Button } from 'antd'
import moment from 'moment'
import { connect } from 'react-redux'
import { CalendarIcon, PlusIcon } from './Icons'
import { getPushPathWrapper } from '../../../routes'

class DashboardHeader extends Component {
  getGreeting = () => {
    const hour = moment().hour()
    if (hour < 12) return 'Good morning'
    if (hour < 17) return 'Good afternoon'
    return 'Good evening'
  }

  render() {
    const user = JSON.parse(localStorage.getItem('user')) || {}
    const name = user.name || 'ARCC Team'

    return (
      <div className={'dashboardHeader'}>
        <div>
          <p className={'dashboardDate'}>{moment().format('dddd, D MMMM YYYY')}</p>
          <h1 className={'dashboardGreeting'}>
            {this.getGreeting()}, <span className={'greetingHighlight'}>{name}</span>
          </h1>
        </div>
        <div className={'dashboardHeaderButtons'}>
          {/*<Button icon={null}><CalendarIcon style={{ width: 16, height: 16, marginRight: 6 }} />View Calendar</Button>*/}
          <Button
            icon="file-add"
            style={{ marginRight: 10 }}
            onClick={() => this.props.dispatch(getPushPathWrapper('onlineAbstractsGroup.addAbstract'))}
          >
            Add Abstract
          </Button>
          <Button
            type="primary"
            icon="plus"
            className="newSubmissionBtn"
            onClick={() => this.props.dispatch(getPushPathWrapper('article.add'))}
          >
            New Submission
          </Button>
        </div>
      </div>
    )
  }
}

// export default DashboardHeader
export default connect()(DashboardHeader)